import { LoadingState } from "@/components/loading-state";
import { Panel } from "@/components/panel";
import { QueryErrorState } from "@/components/query-error-state";
import { useCrossMarketOpportunities } from "@/sdk/hooks/use-cross-market";

// estimated_edge_pct / spread_pct are already percent units (backend
// net_arbitrage_profit_pct / price_range_pct) — never pass through asPercent,
// which would multiply by 100 again.
function formatPctValue(value: number | null | undefined): string {
  if (typeof value !== "number" || !Number.isFinite(value)) {
    return "—";
  }
  return `${value.toFixed(1)}%`;
}

export function CrossMarketPanel() {
  const { data, isLoading, isError, refetch } = useCrossMarketOpportunities(20);
  const opportunities = data?.opportunities ?? [];

  if (isLoading) return <LoadingState text="Loading cross-market..." />;

  return (
    <Panel title="Cross-Market Opportunities">
      {isError ? (
        <QueryErrorState what="cross-market opportunities" onRetry={() => void refetch()} />
      ) : opportunities.length === 0 ? (
        <p className="py-4 text-center text-sm text-white/40">No opportunities</p>
      ) : (
        <div className="space-y-1.5">
          {opportunities.map((opportunity, index) => (
            <div key={`${opportunity.market_a_id}-${opportunity.market_b_id}-${index}`} className="rounded border border-white/5 px-3 py-2">
              <div className="flex items-center justify-between gap-3">
                <p className="max-w-[220px] truncate text-xs text-white/80">
                  {opportunity.question ?? `${opportunity.market_a_source} vs ${opportunity.market_b_source}`}
                </p>
                <span className="ml-2 text-sm font-bold text-green-400">
                  {formatPctValue(opportunity.estimated_edge_pct ?? opportunity.spread_pct)}
                </span>
              </div>
              <p className="mt-0.5 text-xs text-white/30">{opportunity.opportunity_type}</p>
            </div>
          ))}
        </div>
      )}
    </Panel>
  );
}
